var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Do not edit this file, it is auto generated
 */
import { StyledSvgIcon } from '../../styles/svg-icon.styled';
export const BoxCheckmarkIcon = (_a) => {
    var { size = 'md' } = _a, props = __rest(_a, ["size"]);
    return (_jsxs(StyledSvgIcon, Object.assign({ xmlSpace: "preserve", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", "$size": size }, props, { children: [_jsx("path", { d: "m31.538 7.882-.019-.038a.65.65 0 0 0-.302-.282L16.312.684a.65.65 0 0 0-.543.001L.789 7.668a.7.7 0 0 0-.226.166l-.001.001a.64.64 0 0 0-.158.423v14.964c0 .244.137.467.356.576l14.952 7.508.018.004a.6.6 0 0 0 .271.064.6.6 0 0 0 .271-.064c.006-.003.012-.001.018-.004l14.952-7.508a.65.65 0 0 0 .356-.576V8.163a.7.7 0 0 0-.06-.281M16 15.024l-5.969-2.989 13.451-6.622 5.991 2.764zm.043-13.044 5.932 2.738-13.391 6.593L2.53 8.279zM1.693 9.303l13.664 6.843-.002 13.54-13.662-6.86zm28.614 13.522-13.662 6.86.002-13.542 13.66-6.942z" }), _jsx("path", { d: "M13.459 18.969a.644.644 0 0 0-.843-.348l-5.505 2.285L6 18.231a.645.645 0 1 0-1.191.494l1.358 3.271a.644.644 0 0 0 .844.349l6.101-2.533a.646.646 0 0 0 .347-.843" })] })));
};
